"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecursiveOperationSessionRpcLocal = void 0;
const utils_1 = require("@streamr/utils");
const identifiers_1 = require("../../identifiers");
const logger = new utils_1.Logger(module);
class RecursiveOperationSessionRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async sendResponse(report, context) {
        const remoteNodeId = (0, identifiers_1.toNodeId)(context.incomingSourceDescriptor);
        logger.trace('RecursiveOperationResponse arrived: ' + JSON.stringify(report));
        this.options.onResponseReceived(remoteNodeId, report.routingPath, report.closestConnectedNodes, report.dataEntries, report.noCloserNodesFound);
        return {};
    }
}
exports.RecursiveOperationSessionRpcLocal = RecursiveOperationSessionRpcLocal;
//# sourceMappingURL=RecursiveOperationSessionRpcLocal.js.map